import { createContext, useReducer, useContext } from "react";
import masterDataReducer, { initialState } from "./MasterDataReducer";

const MasterDataContext = createContext<any>(initialState);
interface IMasterDataProvider {
  children: any;
}
export const MasterDataProvider = ({ children }: IMasterDataProvider) => {
  const [state, dispatch] = useReducer(masterDataReducer, initialState);

  const saveMasterData = (master: any) => {
    const updatedMaster = { ...state.masters, ...master };
    dispatch({
      type: "SAVE_MASTERDATA",
      payload: { ...updatedMaster },
    });
  };

  const removeMasterData = (master: any) => {
    const updatedMaster = { ...state.masters };
    delete updatedMaster[master];
    dispatch({
      type: "REMOVE_MASTERDATA",
      payload: { ...updatedMaster },
    });
  };
  const clearMasterData = () => {
    dispatch({
      type: "CLEAR_MASTERDATA",
    });
  };
  const value = {
    masters: state.masters,
    saveMasterData,
    removeMasterData,
    clearMasterData,
  };
  return (
    <MasterDataContext.Provider value={value}>
      {children}
    </MasterDataContext.Provider>
  );
};

const useMasterContext = () => {
  const context = useContext(MasterDataContext);

  if (context === undefined) {
    throw new Error("useMasterContext must be used within MasterDataContext");
  }

  return context;
};

export default useMasterContext;
